
import { granjaApi } from "../../api";
import { useDescuentosStore } from "../../store";

import Swal from "sweetalert2";






// export const startLoteDistriXID = async(id) => {
//     try {
//         const { data } = await granjaApi.get(`/distribucion/xid/${id}`);
//         return data.data;
//     } catch (error) {
//         console.log(error)
//         Swal.fire('Error', error.response.data.msg, 'error');
//     }
// }




export const startDescartesXPlanilla = async(id) => {
    try {
        const { data } = await granjaApi.get(`/descarte/xplanilla/${id}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}




// export const startDescuentosXTipo = async({ page=0, descuento='', id, inicio, final }) => {
//     try {
//         const params = new URLSearchParams();
//         params.append('id',  id);
//         params.append('page',  page.toString());
//         params.append('descuento',  descuento);
//         params.append('inicio',  inicio);
//         params.append('final',  final);

//         const { data } = await granjaApi.get('/descuento/xtipo', { params });
//         useDescuentosStore.setState({ totalDescuento: data.total, datosDescuento:data.datos });
//         return data.data;
//     } catch (error) {
//         const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
//         throw new Error(errores);
//     }
// }




// export const startSavingDescuento = async(descuento) => {
//     try {
//         await granjaApi.post('/descuento/new', descuento);
//         Swal.fire('Exitoso', 'Descuento Creado', 'success');
//         return true;
//     } catch (error) {
//         console.log(error);
//         Swal.fire('Error', error.response.data.msg, 'error');
//         return false;
//     }
// } 

